import { SeverityLevel } from '@sentry/react';

import { Sentry } from '@/app/libs/sentry/instance';
import { FeaturesRequest } from '@/app/libs/sentry/types/features';

type Extra =
  | {
      [x: string]: unknown;
    }
  | undefined;

export function captureException<T extends Extra>(
  error: Error,
  feature: FeaturesRequest,
  extra?: T,
  level: SeverityLevel = 'error',
) {
  Sentry.captureException(error, { extra, level, tags: { feature } });
}
